import _ from 'lodash';

import clientsConstants from '../constants/clients-constants';
import constants from '../../../../common/constants';

class ClientsHelpers {
  static formatClientsList(clients) {
    clients.forEach((item) => {
      return item.user_level = this.formatUserLevels(item.user_level);
    });

    let result = clients.map(function(c) {
      return _.chain(c)
        .pick(_.keys(clientsConstants.mapped_clients_keys))
        .mapKeys((value, key) => {
          return clientsConstants.mapped_clients_keys[key];
        })
        .mapValues((value, key) => {
          return value ? value : '-';
        })
        .value();
    });

    return result;
  }

  static hideField(field, isEmail, firstNoChars) {
    if (field) {
      return isEmail
        ? `${field.substring(0, firstNoChars || 2)}...${field.substring(field.indexOf('@'), field.length)}`
        : `${field.substring(0, firstNoChars || 2)}...${field.substring(field.length - 2, field.length)}`;
    } else return '';
  }

  static maskFields(clients, isOnlineAffiliate) {
    let result = [];

    for (let i = 0; i < clients.length; i++) {
      if (isOnlineAffiliate) {
        delete clients[i].first_name;
        delete clients[i].last_name;
        delete clients[i].phone_number;
        delete clients[i].phone_code;
        clients[i].email = this.hideField(clients[i].email, true, 2);
      }

      result.push(clients[i]);
    }

    return result;
  }

  static formatUserLevels(level) {
    const userLevel = _.find(constants.achievements, { value: level });

    return userLevel ? userLevel.text : '';
  }
}

export default ClientsHelpers;



// WEBPACK FOOTER //
// ./src/app/main/clients/helpers/clients-helpers.js